import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Send, ScanSearch, Eye, Handshake } from "lucide-react";
import { Section, SectionHeading, Eyebrow, GlassCard, Reveal } from "../components/ui-shared";

const steps = [
  { n: "01", t: "POST", d: "Tell Orbit what you need — campaign, budget and the kind of creators you're looking for.", icon: Send },
  { n: "02", t: "MATCH", d: "Orbit analyses the campaign and surfaces relevant profiles based on your requirements.", icon: ScanSearch },
  { n: "03", t: "REVIEW", d: "See available content and performance information to make a more informed choice.", icon: Eye },
  { n: "04", t: "CONNECT", d: "Choose who you want to work with and take the conversation forward — directly.", icon: Handshake },
];

export default function HowItWorks() {
  return (
    <div>
      <section className="pt-16 sm:pt-24 pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-3xl">
            <Eyebrow>How it works</Eyebrow>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-white">
              FOUR STEPS. LESS FRICTION.
            </h1>
            <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed max-w-xl">
              Orbit turns a messy, manual process into a structured flow — from a clear brief to the right creators.
            </p>
          </motion.div>
        </div>
      </section>

      <Section className="!pt-10">
        <div className="grid gap-5 md:grid-cols-2">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <GlassCard className="p-7 h-full">
                <div className="flex items-center justify-between">
                  <span className="grid place-items-center h-12 w-12 rounded-xl bg-sky-500/15 border border-sky-400/25 text-sky-300">
                    <s.icon size={20} />
                  </span>
                  <span className="font-mono text-sm text-slate-600">{s.n}</span>
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold text-white">{s.t}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.d}</p>
              </GlassCard>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14 grid gap-6 md:grid-cols-2">
            <div className="rounded-2xl glass p-8">
              <h3 className="font-display text-lg font-semibold text-white">Businesses</h3>
              <p className="mt-2 text-sm text-slate-400">0% platform fee during the Private Beta.</p>
              <Link to="/business-apply" className="btn-primary mt-5">Apply as a Business <ArrowRight size={18} /></Link>
            </div>
            <div className="rounded-2xl glass p-8">
              <h3 className="font-display text-lg font-semibold text-white">Creators</h3>
              <p className="mt-2 text-sm text-slate-400">Private Beta access is completely free.</p>
              <Link to="/creator-apply" className="btn-ghost mt-5">Apply as a Creator <ArrowRight size={18} /></Link>
            </div>
          </div>
        </Reveal>
      </Section>
    </div>
  );
}
